import React from 'react'

const VideoIconSvg = ({ fillColor, size }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 26L42.446 32.964C42.5966 33.0643 42.7715 33.1217 42.9522 33.1304C43.1329 33.139 43.3125 33.0985 43.472 33.0131C43.6315 32.9277 43.7648 32.8007 43.8578 32.6456C43.9508 32.4904 43.9999 32.3129 44 32.132V15.74C44.0001 15.5641 43.9537 15.3912 43.8656 15.2389C43.7774 15.0866 43.6507 14.9603 43.4981 14.8726C43.3456 14.785 43.1726 14.7392 42.9966 14.7398C42.8207 14.7403 42.648 14.7874 42.496 14.876L32 21" stroke={fillColor} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M28 12H8C5.79086 12 4 13.7909 4 16V32C4 34.2091 5.79086 36 8 36H28C30.2091 36 32 34.2091 32 32V16C32 13.7909 30.2091 12 28 12Z" stroke={fillColor}stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}

export default VideoIconSvg